import { render, staticRenderFns } from "./FilterRating.vue?vue&type=template&id=20b04b1e&scoped=true&"
import script from "./FilterRating.vue?vue&type=script&lang=js&"
export * from "./FilterRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b04b1e",
  null
  
)

export default component.exports